export const common = {
  nav: {
    services: 'Servicios',
    about: 'Sobre mí',
    contact: 'Contacto'
  },
  hero: {
    title: 'Webs Profesionales y SEO para Pequeños Negocios',
    subtitle: 'Creo páginas web modernas, rápidas y optimizadas para ayudar a los negocios locales a crecer en internet.',
    primaryBtn: 'Solicitar información',
    secondaryBtn: 'Ver servicios'
  },
  services: {
    title: 'Servicios',
    web: {
      title: 'Creación de Páginas Web',
      description: 'Diseño de páginas web modernas, rápidas y adaptadas a móviles para pequeños negocios.'
    },
    seo: {
      title: 'SEO Local',
      description: 'Optimización para aparecer mejor en Google y atraer más clientes locales.'
    },
    redesign: {
      title: 'Rediseño de Webs',
      description: 'Transformación de webs antiguas en sitios modernos y profesionales.'
    }
  },
  why: {
    title: 'Por qué elegir David Rio Web',
    point1: 'Diseño moderno y profesional',
    point2: 'Webs rápidas y optimizadas',
    point3: 'Estructura preparada para SEO',
    point4: 'Soporte en varios idiomas',
    point5: 'Soluciones para pequeños negocios'
  },
  languages: {
    title: 'Servicios Multilingües',
    description: 'Trabajo con negocios que quieren llegar a clientes internacionales.',
    spanish: 'Español',
    english: 'English',
    russian: 'Русский'
  },
  about: {
    title: 'Sobre David Rio',
    description: 'Desarrollador web freelance especializado en la creación de páginas web modernas y estrategias de SEO para pequeños negocios. Mi objetivo es ayudar a empresas locales a tener una presencia profesional en internet.'
  },
  contact: {
    title: 'Contacto',
    name: 'Nombre',
    email: 'Email',
    phone: 'Teléfono',
    message: 'Mensaje',
    submit: 'Contactar',
    sending: 'Enviando...',
    success: '¡Mensaje enviado con éxito!',
    error: 'Error al enviar el mensaje. Por favor, inténtalo de nuevo.'
  },
  footer: {
    copyright: '© 2026 David Rio Web',
    credit: 'Web diseñada y creada por David Rio'
  },
  portfolio: {
    title: 'Proyectos Web',
    description: 'Algunos ejemplos de páginas web modernas diseñadas para pequeños negocios.',
    project1: {
      title: 'Web para Negocio Local',
      description: 'Sitio web moderno para un negocio de servicios locales con optimización móvil y carga rápida.'
    },
    project2: {
      title: 'Web para Restaurante',
      description: 'Página web profesional para restaurante incluyendo menú, ubicación y contacto.'
    },
    project3: {
      title: 'Web para Salón de Belleza',
      description: 'Sitio web elegante para salón de belleza con servicios y galería.'
    }
  },
  process: {
    title: 'Cómo Trabajo',
    step1: {
      title: 'Análisis',
      description: 'Estudio las necesidades del negocio y los objetivos del cliente.'
    },
    step2: {
      title: 'Diseño y Desarrollo',
      description: 'Creo una web moderna, rápida y optimizada.'
    },
    step3: {
      title: 'Publicación y Optimización',
      description: 'La web se publica y se optimiza para buscadores.'
    }
  }
};